import React from 'react';
import PropTypes from 'prop-types';
import { ArrowBottomIcon, Badge } from '@paygreen/paygreen-ui';
import { IsDesktop } from '../../utils/tools';

const ClimateKitBadge = ({ textSize, hasArrow, isShorten, colorType }) => {
    return (
        <Badge
            textSize={textSize || (IsDesktop() ? 'tiny' : 'xxs')}
            colorType={colorType}
        >
            {!isShorten ? 'climate' : 'cli'}

            {hasArrow ? <ArrowBottomIcon marginLeft="xs" /> : null}
        </Badge>
    );
};

ClimateKitBadge.propTypes = {
    hasArrow: PropTypes.bool,
    textSize: PropTypes.string,
    isShorten: PropTypes.bool,
    colorType: PropTypes.string,
};

ClimateKitBadge.defaultProps = {
    hasArrow: false,
    textSize: 'tiny',
    isShorten: false,
    colorType: 'original',
};

export default ClimateKitBadge;
